export default "__VITE_ASSET__SE5pipcT__"